export default __webpack_public_path__ + "static/media/analog-clock-white.a117c5f3.png";